module.exports = __webpack_public_path__ + "img/cir.8804d98b.jpg";